import request from '../../../utils/request'




export const resourceTokenGenerate = (data: any) => {
  return request({
    url: '/api/design/resource/token',
    method: 'post',
    data
  })
}
export const getFontList = (params) => {
  return request({
    url: '/api/design/font/pages',
    method: 'get',
    params
  })
}
export function resourcerFileUpload(file: File, parentId?: number) {
  const formData = new FormData()
  formData.append('file', file)
  if (parentId) {
    formData.append('parent_id', parentId.toString())
  }
  return request({
    url: '/api/design/resource/file',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const getUserResourcePages = (params: any) => {
  return request({
    url: '/api/design/resource/pages',
    method: 'get',
    params
  })
}
export function saveFont(data: Record<string, any>) {
  return request({
    url: '/api/saveFont',
    method: 'post',
    data,
    baseURL: 'https://www.aishanyin.com'
  })
}

export const getTemplateData = (params: any) => {
  return request({
    url: `/api/design/template/data`,
    method: 'get',
    params
  })
}
export function saveCanvasDpi(data: Record<string, any>) {
  return request({
    url: '/api/saveCanvasDpi',
    method: 'post',
    data,
    baseURL: 'https://www.aishanyin.com'
  })
}
export function getCanvasDpi(data: Record<string, any>) {
  return request({
    url: '/api/getCanvasDpi',
    method: 'post',
    data,
    baseURL: 'https://www.aishanyin.com'
  })
}
export function searchbyimage(data: Record<string, any>) {
  return request({
    url: '/api/design/material/search-by-image',
    method: 'get',
    params: data,
    baseURL: 'https://engine.aishanyin.com'
  })
} 